var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 18.3327C6.07293 18.3327 4.10875 18.3327 2.88836 17.1123C1.66797 15.8919 1.66797 13.9277 1.66797 9.99935C1.66797 6.07098 1.66797 4.10679 2.88836 2.8864C4.10875 1.66602 6.07293 1.66602 10.0013 1.66602C13.9297 1.66602 15.8939 1.66602 17.1142 2.8864C18.3346 4.10679 18.3346 6.07098 18.3346 9.99935C18.3346 13.9277 18.3346 15.8919 17.1142 17.1123C15.8939 18.3327 13.9297 18.3327 10.0013 18.3327ZM13.3599 7.47407C13.604 7.71815 13.604 8.11388 13.3599 8.35796L9.19324 12.5246C8.94917 12.7687 8.55344 12.7687 8.30936 12.5246L6.64269 10.858C6.39862 10.6139 6.39862 10.2182 6.64269 9.97407C6.88677 9.73 7.2825 9.73 7.52658 9.97407L8.7513 11.1988L12.476 7.47407C12.7201 7.23 13.1158 7.23 13.3599 7.47407Z",
    fill: "#00BA4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSquare);
export default __webpack_public_path__ + "static/media/success-square.035d076fd5be3e3e38f8c0670d990cd6.svg";
export { ForwardRef as ReactComponent };